import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M24 46.5c12.426 0 22.5-10.074 22.5-22.5S36.426 1.5 24 1.5 1.5 11.574 1.5 24 11.574 46.5 24 46.5m0 1.5c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M22.74 26.75h2.52l-.566-3.158c.314-.134.567-.345.759-.633.192-.288.287-.608.287-.959 0-.48-.17-.89-.51-1.23-.34-.34-.75-.51-1.23-.51s-.89.17-1.23.51c-.34.34-.51.75-.51 1.23 0 .351.095.67.287.959.192.288.445.499.759.633zM24 33.48c-2.163-.589-3.953-1.862-5.372-3.818-1.419-1.957-2.128-4.144-2.128-6.562v-5.754L24 14.54l7.5 2.807V23.1c0 2.418-.71 4.605-2.128 6.561-1.419 1.957-3.21 3.23-5.372 3.82Zm0-1.58c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5v-4.725l-6-2.24-6 2.24V23.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }